import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import {
  GAME_STATUS,
  pickCard,
  selectGameStatus,
  releaseMatchingCard
} from './gameSlice'
import BackgroundImage from '../../components/BackgroundImage'
import './FlipCard.css'

const root = process.env.PUBLIC_URL
const frontCoverSrc = `${root}/assets/game/img/card-cover.svg`

const FlipCard = ({ src, card, lang }) => {

  const gameStatus = useSelector(selectGameStatus)

  const dispatch = useDispatch()

  const handleClick = () => {
    if (card.paired || card.matching) return
    if (gameStatus === GAME_STATUS.IDLE || gameStatus === GAME_STATUS.FLIP_1) {
      dispatch(pickCard(card.id))
      // setTimeout(() => dispatch(releaseMatchingCard(card.id)), 8)   // for debug
      setTimeout(() => dispatch(releaseMatchingCard(card.id)), 800)
    }
  }

  let renderedCardBack
  if (card.pairType === 'img') {
    renderedCardBack = <BackgroundImage
      src={src}
      posX={card.posX}
      posY={card.posY}
    />
  } else if (card.pairType === 'word') {
    renderedCardBack = <span>{card[lang]}</span>
  }

  const cardOpen = card.paired || card.matching

  return (
    <div
      className={`flip-card ${cardOpen ? 'active' : ''} ${card.matching ? 'matching' : ''}`}
      onClick={handleClick}
    >
      <div className="flip-card-inner">
        <div className="flip-card-front flex-center">
          <img src={frontCoverSrc} />
        </div>
        <div className="flip-card-back flex-center">
          {renderedCardBack}
        </div>
      </div>
    </div>
  )
}

export default FlipCard